/**
 * The extension for a ContractCase contract file.
 */
export const EXTENSION = '.case.json' as const;
